import { render, staticRenderFns } from "./GradeRecord.vue?vue&type=template&id=5911383e&scoped=true"
import script from "./GradeRecord.vue?vue&type=script&lang=js"
export * from "./GradeRecord.vue?vue&type=script&lang=js"
import style0 from "./GradeRecord.vue?vue&type=style&index=0&id=5911383e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5911383e",
  null
  
)

export default component.exports